<template>
  <div>
    <div class="home-header">
      <div class="header-search">
        <van-field @click-input="checkInput" v-model="value1" placeholder="请输入产品名称">
          <template #right-icon>
            <svg-icon icon-class="home_search"></svg-icon>
          </template>
        </van-field>
        <!-- <div class="header-search-img" @click.prevent="goinfo">
          <svg-icon icon-class="home_info"></svg-icon>
        </div> -->
      </div>
      <div class="home-swipe">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item,index) in bannerList" :key="index">
            <img @click="checkImg(item.product)" class="swipe-img" :src="item.imgUrl" alt="">
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <product-library></product-library>
    <div class="home-product">
      <div class="home-pro-title">
        <div class="pro-title-left">
          <svg-icon icon-class="home_pro_line"></svg-icon>
          <span>产品库</span>
        </div>
        <div class="pro-title-right" @click.prevent="moreProduct">
          <span>更多</span>
          <svg-icon icon-class="home_pro_more"></svg-icon>
        </div>
      </div>
      <div class="home-pro-img">
        <van-tabs type="card" v-model="active">
          <van-tab
            :title="item.name"
            v-for="(item, index) in productList"
            :key="index"
            :name="item.name"
          >
            <van-swipe :loop="false" :width="116" touchable :show-indicators="false">
              <van-swipe-item v-for="(it,ind) in item.value" :key="ind" >
                <div class="swipe-img">
                  <img :src="it.img" @click.prevent="checkImg(it)"/>
                </div>
              </van-swipe-item>
            </van-swipe>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="home-product home-article">
      <div class="home-pro-title">
        <div class="pro-title-left">
          <svg-icon icon-class="home_pro_line"></svg-icon>
          <span>热门文章</span>
        </div>
        <div class="pro-title-right" @click.prevent="moreArticles">
          <span>更多</span>
          <svg-icon icon-class="home_pro_more"></svg-icon>
        </div>
      </div>
      <div class="home-article-nav">
        <ul>
          <li
            v-for="(item,index) in liList"
            :key="index"
            :class="isLink==index ? 'li-style li-check-style' : 'li-style'"
            @click="chooseLi(item,index)"
          >{{item.name}}</li>
        </ul>
        <ul class="home-nav2">
          <li
            v-for="(item,index) in liList2"
            :key="index"
            :class="isLink2==index ? 'li-style2 li-check-style2' : 'li-style2'"
            @click="chooseLi2(item,index)"
          >
            {{item.name}}
            <svg-icon v-if="isLink2==index" icon-class="home_line2"></svg-icon>
          </li>
        </ul>
      </div>
      <!-- 置顶文章 -->
      <div v-if="level1=='1' && level2=='推荐' ">
        <div  class="home-data-list" v-for="(item,index) in dataList " :key="'home0'+index">
        <div v-if="item.contentType=='ART'" class="home-list-sty" @click.prevent="goToDetails(item.artcId,item.coverLink)">
          <!-- <div class="list-left">
            <img src="./img/home_article1.png" alt />
          </div> -->
          <div class="list-right list-top-right">
            <div class="list-r-tit">
              <!-- <img src="./img/home_name0.png" alt /> -->
              <svg-icon  icon-class="home_name2"></svg-icon>
              <span>{{item.title}}</span>
            </div>
            <div class="list-r-foot">
              <span class="list-top-span">置顶</span>
              <span>阅读 {{item.viewCount || 0}} 次</span>
            <span>转发 {{item.fwdCount || 0}} 次</span>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="list-top-line"></div>
      <!-- 推荐文章列表 -->
      <div class="home-data-list" v-for="(item,index) in dataList1 " :key="'home1'+index">
        <!-- 文章 -->
        <div v-if="item.contentType=='ART'" class="home-list-sty" @click.prevent="goToDetails(item.artcId,item.coverLink)" >
          <div class="list-left">
            <img :src="item.coverLink" alt />
          </div>
          <div class="list-right">
            <div class="list-r-tit">
              <!-- <img src="./img/home_name0.png" alt /> -->
              <svg-icon icon-class="home_name2"></svg-icon>
              <span>{{item.title}}</span>
            </div>
            <div class="list-r-foot">
              <span>阅读 {{item.viewCount || 0}} 次</span>
            <span>转发 {{item.fwdCount || 0}} 次</span>
            </div>
          </div>
        </div>
        <!-- 图文 -->
        <div v-if="item.contentType=='PAW'">
          <div class="list-r-tit">
            <!-- <img src="./img/home_name1.png" alt /> -->
            <svg-icon icon-class="home_name1"></svg-icon>
            <span>{{item.artcSummary}}</span>
          </div>
          <div class="home-imgList-sty">
            <!-- 图片大于一张 并且不是四张 -->
            <div v-if="item!=4" class="home-isImg">
              <div
                v-for="(it,ind) in item.imgurl"
                :key="'inedex2'+ind"
                :class="item > 1 && item!=4 ? 'home-img-size home-img-size2':'home-img-size'"
              >
                <div>
                  <van-image
                    @click="sceneImg(item,$event)"
                    v-if="it"
                    width="100%"
                    height="100%"
                    :src="it"
                  />
                </div>
              </div>
            </div>
            <!-- 图片是四张 -->
            <div v-if="item==4" class="home-isImg">
              <div v-for="(itS,indS) in item.imgurl" :key="'index0'+indS" class="home-img-size4">
                <div>
                  <van-image
                    @click="sceneImg(item,$event)"
                    v-if="itS.img"
                    width="100%"
                    height="100%"
                    :src="itS.img"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="list-r-foot list-igm-foot">
            <span>阅读 {{item.viewCount || 0}} 次</span>
            <span>转发 {{item.fwdCount || 0}} 次</span>
          </div>
        </div>
        <!-- 视频 -->
        <div v-if="item.contentType=='VOD'">
          <div class="list-r-tit">
            <!-- <img src="./img/home_name2.png" alt /> -->
            <svg-icon icon-class="home_name3"></svg-icon>
            <span>{{item.vtitle}}</span>
          </div>
          <div class="home-imgList-sty">
            <div class="home-img-size" >
              <div>
                <van-image
                  @click="goToVideo('inner',item.artcId)"
                  width="100%"
                  height="100%"
                  :src="item.faceImgUrl || item.imgUrl1"
                  style="object-fit: cover;"
                />
              </div>
            </div>
          </div>
          <div class="list-r-foot list-igm-foot">
            <span>阅读 {{item.viewCount || 0}} 次</span>
            <span>转发 {{item.fwdCount || 0}} 次</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast, Dialog } from "vant";
import { jspay, setSession, setLocal } from "@/utils/utils";
import productLibrary from './productLibrary.vue';
export default {
  components: { productLibrary },
  data() {
    return {
      active: '1',
      productList: [],
      value1: '',
      isLink: '0',
      isLink2: '0',
      videoNowPage:'1',
      liList: [
        { id: 1, name: '全部' },
        { id: 2, name: '文章' },
        { id: 3, name: '图文' },
        { id: 4, name: '视频' },
      ],
      liList2: [
        { id: 1, name: '推荐' },
        { id: 2, name: '贷款' },
        { id: 3, name: '保险' },
        { id: 4, name: '健康' },
        { id: 5, name: '教育' },
        { id: 6, name: '汽车' },
        { id: 7, name: '财经' },
        { id: 8, name: '生活' },
        { id: 9, name: '互动' },
      ],
      level1: '1',
      level2: '推荐',
      dataList: [],
      dataList1: [],
      id: "",
      code: "",
      ket: 0,
      bannerList: [],
    }
  },
  mounted() {
    this.getBanner();
    this.fatchdata()
    this.getArticles()
    this.getTopArticle()
    if (localStorage.getItem('openid')) {
      this.checkIsLoginAndAuth(localStorage.getItem('openid'))
    }
  },
  methods: {
    checkImg(v){
      // 产品库
    },
    // goinfo(){//消息
    //   this.$router.push('/information')
    // },
    getTopArticle() {
      let that = this
      that.$fetchPost(URL.getTopArticle.url,{
        open_id: localStorage.getItem('openid'),
        teb_type: that.level2 === '推荐' ? '' : that.level2
      }).then(res => {
        that.dataList = res.data
      })
    },
    getArticles(){
      let that = this
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      that.$fetchPost(URL.getHomeArticle.url,{
        now_page: that.pageNum,
        row_num: 20,
        open_id: localStorage.getItem('openid'),
        teb_type: that.level2 === '推荐' ? '' : that.level2,
        file_type: that.level1
      }).then(res => {
        if(res.data){
          Toast.clear();
          that.dataList1=res.data.slice(0,5)
        }

      })
    },
    goToDetails(id, imgUrl) {
      this.$router.push({
        name: "articleDetailsC",
        query: {
          articleId: id,
          picUrl: imgUrl,
          openId: sessionStorage.getItem("openId"),
          canBack: "y",
          showLongBtn: 'n'
        }
      })
    },
    fatchdata() {
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      this.$fetchGet(URL.findplist.url, { flag: 0, createCompany: 'ZFKJ' }).then(res => {
        Toast.clear();
        this.productList = res.data.slice(1);

      })
    },
    // 图文
    sceneImg(ele, e) {
    this.$router.push({path:'/graphicDetails',query:{articleId:ele.artcId}})
    },
    chooseLi(item, i) {
      this.isLink = i
      // this.level1 = item.name
      this.level1 = item.id
      this.getArticles()
    },
    chooseLi2(item, i) {
      this.isLink2 = i
      this.level2 = item.name
      this.getArticles()
    },
    moreArticles() {
      this.$router.push('/moreArticlesC')
    },
    moreProduct(){
      this.$router.push('/productTC')
    },
    // 搜索页面
    checkInput() {
      this.$router.push({
        path: '/search',
        query: { inputFocus: 1 }
      })
    },
    // 轮播图片
    getBanner() {
      this.$fetchGet(URL.bannerList.url).then((res) => {
        this.bannerList = res.data.data;
      });
    },
    goToVideo(type, indexOrActId) {
      //跳转到视频页面
      let nowpage = 0
      let index = 0

      if (type === 'inner') {
        this.$router.push({
          name: "video",
          query: {
            articleId: indexOrActId
          }
        })
      } else {
        if (type === 'more') {
          nowpage = 3
          index = 0
        } else if (type === 'third') {
          nowpage = Math.ceil((indexOrActId + 1) / 5)
          index = indexOrActId % 5
        }
        this.$router.push({
          name: "video",
          query: {
            now_page: nowpage,
            teb_type: this.artile_type === '推荐' ? '' : this.artile_type,
            currentIndex: index
          }
        })
      }
    },
    checkIsLoginAndAuth(openid) {
      this.$fetchPost(URL.getBindingInfo.url, this.$toFormData({ 'openid': openid })).then(res => {
        if (res.data.code == 20000) {
          let phoneNo = res.data.data.phoneNo;
          this.phoneNo = phoneNo
          let authFlag = res.data.data.authFlag;
          let realName = res.data.data.realName;
          let nickName = res.data.data.nickName;
          let headImg = res.data.data.headImg;
          setLocal('phoneNoC', phoneNo);
          setLocal("authFlagC", authFlag);
          setLocal("realNameC", realName);
          setLocal("nickNameC", nickName);
          setLocal("headImgC", headImg);
          setLocal("cip", res.data.data.ip);
        } 
      })
    },
  },
}
</script>

<style lang="less" scoped>
.home-header {
  width: 375px;
  height: 170px;
  background: #fff;
  margin: auto;
  overflow: hidden;
  .header-search {
    width: 345px;
    height: 35px;
    margin: 9.5px auto 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .svg-icon {
      width: 17.48px;
      height: 17.48px;
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
    }
    .header-search-img{
      height: 35px;
      position: relative;
    }
    /deep/ .van-badge__wrapper{
      height: 35px;
      // line-height: 30px;
    }
  }
  .van-cell {
    width: 355px;
    height: 28px;
    margin-left: 6px;
    line-height: 28px;
    padding: 0 0 0 16px;
    border-radius: 33.5px;
    border: 1px solid #fc6e09;
    .svg-icon {
      padding-right: 7.5px;
    }
  }
  .home-swipe {
    width: 345px;
    height: 99px;
    margin: 11px auto 0 auto;
    .swipe-img {
      width: 345px;
      height: 99px;
    }
  }
}
.home-product {
  width: 375px;
  height: 243px;
  margin-top: 10px;
  // padding-bottom: 18.5px;
  margin-bottom: 10px;
  background: #fff;
  overflow: hidden;
  .home-pro-title {
    width: 345px;
    margin: 10px auto 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .pro-title-left {
    display: flex;
    align-items: center;
    .svg-icon {
      width: 2px;
      height: 13px;
    }
    span {
      padding-left: 14px;
      font-size: 15px;
      font-weight: Bold;
      font-family: "PingFang SC";
      color: #333333;
    }
  }
  .pro-title-right {
    display: flex;
    align-items: center;
    span {
      display: flex;
      padding-right: 7px;
      font-size: 13px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #666666;
    }
    .svg-icon {
      width: 4.73px;
      height: 5.4px;
    }
  }
  .home-pro-img {
    width: 345px;
    margin: 11.5px auto 0 auto;
    .van-swipe {
      margin-top: 16px;
    }
    /deep/ .van-tabs__nav--card .van-tab {
      //   border: 0;
      border-right: 0.5px solid #ededed;
    }
    /deep/ .van-tabs__nav--card .van-tab:last-child {
      //   border: 0;
      border-right: 0;
    }
    /deep/ .van-tabs__nav--card {
      width: 100%;
      padding: 0;
      margin: 0;
      border: 0;
    }
    /deep/.van-tabs__wrap {
      height: 33px;
    }
    /deep/.van-tabs__nav--card .van-tab.van-tab--active {
      font-size: 14px;
      font-weight: bold;
      font-family: PingFang SC;
      color: #333333;
      background: url("../imgs/home_bg1.png") no-repeat 100%;
      background-size: 100% 100%;
      //   border: 1px solid;
      width: 115px;
      height: 33px;
    }
    /deep/.van-tabs__nav--card .van-tab {
      font-size: 14px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #333333;
      background: url("../imgs/home_bg2.png") no-repeat;
      background-size: 100% 100%;
      //   border: 1px solid;
      width: 115px;
      height: 33px;
    }
    .swipe-img {
      img {
        width: 96px;
        height: 137px;
      }
    }
  }
  //   .van-swipe-item:not(:first-child){
  //       margin-left: 10px;
  //   }
}
.home-article {
  height: auto;
   padding-bottom: 15px;
  .home-article-nav {
    width: 345px;
    margin: 11px auto 0 auto;
    list-style: none;
    ul {
      display: flex;
      font-size: 11px;
      justify-content: space-between;
    }
    .li-style {
      width: 72.5px;
      height: 21.5px;
      line-height: 21.5px;
      text-align: center;
      background: url("../imgs/home_bg3_1.png") no-repeat 100%;
      background-size: 100% 100%;
      font-size: 11px;
      font-family: PingFang SC;
      font-weight: Medium;
      color: #333333;
    }
    .li-check-style {
      background: url("../imgs/home_bg3.png") no-repeat 100%;
      background-size: 100% 100%;
      color: #fc6e09;
    }
    .home-nav2 {
      ul {
        width: 345px;
        overflow-x: scroll;
      }
      margin-top: 12.5px;
      .svg-icon {
        width: 13.5px;
        height: 2px;
        display: block;
        margin-left: 5.5px;
        margin-top: 2.5px;
      }
      .li-style2 {
        width: 24.5px;
        font-size: 12px;
        font-family: PingFang SC;
        color: #333333;
        font-weight: Regular;
      }
      .li-check-style2 {
        font-weight: Regular;
        color: #fc6e09;
      }
    }
  }
  .home-data-list {
    width: 345px;
    margin: 16.5px auto 0 auto;
    .home-list-sty:not(:first-child) {
      margin-top: 28px;
    }
    .home-list-sty {
      width: 100%;
      height: 57px;
      display: flex;
      .list-left {
        width: 95px;
        height: 57px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .list-right {
        width: calc(345px - 110px);
        margin-left: 15.5px;
      }
      .list-top-right{
        width: 100%;
        margin: 0;
      }
    }
    .list-r-tit {
      height: 27px;
      line-height: 12.5px;
      display: flex;
      align-items: flex-start;
      span {
        display: block;
        width: 197px;
        height: 26px;
        margin-left: 8px;
        overflow: hidden;
        font-size: 10.5px;
        font-weight: Medium;
        font-family: PingFang SC;
        color: #333333;
      }
      .svg-icon {
        width: 27.5px;
        height: 17px;
      }
    }
    .list-r-foot {
      height: 12.5px;
      line-height: 0;
    display: flex;
    margin-top: 20px;
      span {
        height: 12.5px;
        display: flex;
        font-size: 9px;
        font-weight: Regular;
        font-family: PingFang SC;
        color: #999999;
      }
      .list-top-span{
        color: #ff2e2e;
        margin-right: 5px;
      }
    }
    .list-r-foot span:last-child {
      padding-left: 5px;
    }
    .list-igm-foot {
      display: flex;
      margin-top: 10px;
    }
    .home-imgList-sty {
      width: 100%;
      margin: 9px auto 0 auto;
      .home-isImg {
        display: flex;
        flex-wrap: wrap;
      }
      .home-img-size {
        width: 100%;
      }
      .home-img-size2 {
        width: 110px;
        height: 64px;
        margin-top: 5px;
      }
      .home-img-size2:nth-child(n) {
        margin-right: 7.5px;
      }
      .home-img-size2:nth-child(3n) {
        margin: 0;
      }
      .home-img-size4 {
        width: 40%;
        margin-right: 7.5px;
      }
    }
  }
  .list-top-line{
    width: 345px;
    height: 1px;
    margin: 16.5px auto 0 auto;
    background: #F8F8F8;
  }
}
.van-popup {
  width: 80%;
  background: transparent;
}
.van-popup img {
  width: 100%;
  position: relative;
}
.popup-buttom {
  color: transparent;
  position: absolute;
  bottom: 38px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
